export default "/_next/static/data/cpd_week_lottie_footer.json-2240940acc16ff2558a8d6c4275034a9.json";